import React from "react";

import MDBox from "@/components/atoms/MDBox";

export type SuspenseProps = {
  isSuspended?: boolean;
  fallback: React.ReactNode;
  children: React.ReactNode;
};

const Suspense: React.FC<SuspenseProps> = ({ children, isSuspended = false, fallback }) => {
  if (isSuspended)
    return (
      <MDBox p={2} display="flex" alignItems="center" justifyContent="center">
        {fallback}
      </MDBox>
    );

  return <>{children}</>;
};

export default Suspense;
